import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { getScanReportDates } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-stats'
import Menu from '/components/templates/template-nav-menu'
import DatesTable from '../components/templates/scan-report-dates-table'

const TemplateScanReports = () => {

  const navigate = useNavigate()
  const { templateId } = useParams()
  const { apiSource,apiKey,loadingTemplates, templates } = useContext(AppContext)

  const [dates,setDates] = useState([])
  const [loading, setLoading] = useState(true)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  useEffect(() => {
    if(!loadingTemplates && !template) navigate("/templates")
    getScanReportDateData()
  }, [loadingTemplates, template, navigate])
  
  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  const getScanReportDateData = async () => {
    const d = await getScanReportDates({apiSource,apiKey,templateId})
    
    if (d.error) {
      enqueueSnackbar({ message: d.error, variant: 'error' })
    } else {
      setDates(d.dates)
      setLoading(false)
    }
    setLoading(false)
  }

  const viewReport = ts => {
    navigate("/templates/" + templateId + "/scan-reports/" + ts)
  }

  return (
    <PageWrapper title="Daily Scan Reports" HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <DatesTable dates={dates} loading={loading} viewReport={viewReport}/>
    </PageWrapper>
  )
}

export default TemplateScanReports
